var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8770_85226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16C12.6683 16 16.25 12.4183 16.25 8C16.25 3.58172 12.6683 0 8.25 0C3.83172 0 0.25 3.58172 0.25 8C0.25 12.4183 3.83172 16 8.25 16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90379 3.12952C1.27538 3.94711 0.801541 4.88945 0.525635 5.91317H4.68745L1.90379 3.12952Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9745 5.91314C15.6986 4.88945 15.2247 3.94711 14.5963 3.12952L11.8127 5.91314H15.9745Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.525635 10.087C0.801572 11.1107 1.27542 12.0531 1.90379 12.8706L4.68735 10.087H0.525635Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1205 1.65382C12.3029 1.02542 11.3606 0.551572 10.3369 0.275635V4.43742L13.1205 1.65382Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37939 14.3463C4.19699 14.9747 5.13933 15.4486 6.16302 15.7245V11.5627L3.37939 14.3463Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16299 0.275635C5.1393 0.551572 4.19696 1.02542 3.37939 1.65379L6.16299 4.43738V0.275635Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3369 15.7245C11.3606 15.4486 12.3029 14.9747 13.1205 14.3463L10.3369 11.5627V15.7245Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8127 10.087L14.5963 12.8707C15.2247 12.0531 15.6986 11.1107 15.9745 10.087H11.8127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1823 6.95653H9.29353H9.2935V0.0677188C8.95191 0.02325 8.60366 0 8.25 0C7.89628 0 7.54809 0.02325 7.20653 0.0677188V6.95647V6.9565H0.317719C0.27325 7.29809 0.25 7.64634 0.25 8C0.25 8.35372 0.27325 8.70191 0.317719 9.04347H7.20647H7.2065V15.9323C7.54809 15.9768 7.89628 16 8.25 16C8.60366 16 8.95191 15.9768 9.29347 15.9323V9.04353V9.0435H16.1823C16.2268 8.70191 16.25 8.35372 16.25 8C16.25 7.64634 16.2268 7.29809 16.1823 6.95653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3369 10.0869L13.9068 13.6568C14.071 13.4927 14.2276 13.3211 14.377 13.1432L11.3207 10.0869H10.3369V10.0869Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16292 10.087H6.16286L2.59302 13.6569C2.75714 13.8211 2.92874 13.9777 3.10661 14.1271L6.16292 11.0708V10.087Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16293 5.91311V5.91305L2.59305 2.34314C2.42887 2.50726 2.27224 2.67886 2.1228 2.85673L5.17915 5.91308H6.16293V5.91311Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3369 5.91308L13.9068 2.34314C13.7427 2.17896 13.5711 2.02233 13.3932 1.87292L10.3369 4.92927V5.91308Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8770_85226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngIcon);
export default __webpack_public_path__ + "static/media/eng-icon.35028b6db341515c0df218b8529559b9.svg";
export { ForwardRef as ReactComponent };